import { Col, Form, Input, Row, Select, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";

import AppContainer from "~v2/components/AppContainer/AppContainer";
import { OPTIONS } from "../../../constants";
import ViewAccounts from "../../components/ViewAccounts/ViewAccounts";
import { getAccounts } from "../../http-request/user";
import styles from "./styles/AccountPage.module.css";

const { Text } = Typography;

const ManageAccountPageView = () => {
  const [allAccounts, setAllAccounts] = useState([]);
  /** accounts is pass as a parameter for the mapped component */
  const [accounts, setAccounts] = useState([]);
  const [forms] = Form.useForm();
  const loadAccounts = async () => {
    const token = localStorage.getItem("token");
    await getAccounts(token).then((res) => {
      if (res.length > 0) {
        setAllAccounts(res);
        setAccounts(res);
      }
    });
  };

  const onChangeSelection = (value) => {
    let _accounts = allAccounts.filter((account) =>
      value !== "All" ? account.usertype === value : account
    );
    setAccounts(_accounts);
  };

  const onChangeInput = (e) => {
    let _value = e.target.value.toLowerCase();
    let _accounts = allAccounts.filter(
      (account) =>
        account.firstname.toLowerCase().includes(_value) ||
        account.lastname.toLowerCase().includes(_value)
    );
    setAccounts(_accounts);
  };

  useEffect(() => {
    loadAccounts();
  }, []);

  useEffect(() => {
    let selection = forms.getFieldValue("selection");
    forms.setFieldsValue({ input: "" });

    onChangeSelection(selection);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allAccounts]);

  return (
    <AppContainer title="View User Accounts">
      <center>
        <div style={{ margin: "20px 0px", width: "80vw" }}>
          <Form form={forms} initialValues={{ selection: "All" }}>
            <Space
              direction="vertical"
              size={"middle"}
              style={{ width: "100%" }}
            >
              <Row align="middle">
                <Col span={8}>
                  <Text className={styles.alignLeft}>Search User:</Text>
                </Col>
                <Col span={16}>
                  <Form.Item name={"input"} style={{ margin: 0 }}>
                    <Input onChange={onChangeInput} />
                  </Form.Item>
                </Col>
              </Row>
              <Row align="middle">
                <Col span={8}>
                  <Text className={styles.alignLeft}>View by Type:</Text>
                </Col>
                <Col span={16}>
                  <Form.Item name={"selection"} style={{ margin: 0 }}>
                    <Select
                      onChange={onChangeSelection}
                      options={OPTIONS.userTypeValuesAll}
                      style={{ width: "100%", textAlign: "left" }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <ViewAccounts loadAccounts={loadAccounts} accounts={accounts} />
            </Space>
          </Form>
        </div>
      </center>
    </AppContainer>
  );
};

export default ManageAccountPageView;
